export default {
  title: 'Dashboard',
  newProjects: {
    title: 'Nouvelles demandes',
  },
  calls: {
    title: 'A rappeler',
  },
  meetingsToday: {
    title: 'Rendez-vous pris dans la journée',
  },
  nextProjects: {
    title: 'Projets suivant',
  },
  filesProcessed: {
    title: 'Dossiers traités',
  },
  finished: "<h3>Félicitations !</h3><p>Vous avez terminé 👏</p>",
};
